// Routes to an offer (Miles 2026-11-03). TECH = the screens they tap (bb_tech_journeys, pages joined by choices);
// IRL = the steps to buy and be delivered with no tech walk-through (bb_chains, steps joined by connections).
// A route's length is the number of screens or steps to "got there"; the shortest one is "optimal".

// Pages reachable from `start` inside one journey, breadth-first, with the shortest path to each.
function walk(start, choices) {
  const next = new Map();
  for (const c of choices) {
    if (!next.has(c.source_page_id)) next.set(c.source_page_id, []);
    next.get(c.source_page_id).push(c.target_page_id);
  }
  const prev = new Map([[start, null]]), order = [start];
  for (let i = 0; i < order.length; i++) {
    for (const t of next.get(order[i]) || []) if (!prev.has(t)) { prev.set(t, order[i]); order.push(t); }
  }
  return { order, prev };
}

function pathTo(id, prev) {
  const out = [];
  for (let at = id; at != null; at = prev.get(at)) out.unshift(at);
  return out;
}

// The screens of a journey from `from` (default its first page): to the nearest "got there" page if there is
// one, otherwise every page it reaches.
export function techPath(journey, from, pagesById, choices) {
  const own = choices.filter(c => c.journey_id === journey.id);
  const start = from || journey.starting_page_id || own[0]?.source_page_id;
  if (!start) return [];
  const { order, prev } = walk(start, own);
  const got = order.find(id => pagesById.get(id)?.kind === 'got');
  return (got ? pathTo(got, prev) : order).map(id => pagesById.get(id)).filter(Boolean);
}

export function reaches(journey, pageId, choices) {
  const own = choices.filter(c => c.journey_id === journey.id);
  const start = journey.starting_page_id || own[0]?.source_page_id;
  return !!start && walk(start, own).prev.has(pageId);
}

// A chain's steps in order: follow its connections from the audience (or the first step) to the offer.
export function irlSteps(chain, stepsById) {
  const conns = chain.connections || [];
  const nextOf = new Map(conns.filter(c => c.from_segment_kind === 'step' && c.to_segment_kind === 'step')
    .map(c => [c.from_segment_id, c.to_segment_id]));
  const targets = new Set(conns.filter(c => c.to_segment_kind === 'step').map(c => c.to_segment_id));
  const first = conns.find(c => c.from_segment_kind === 'audience' && c.to_segment_kind === 'step')?.to_segment_id
    || (chain.steps || []).find(s => !targets.has(s.id) && !s.parent_step_id)?.id;
  const out = [], seen = new Set();
  for (let at = first; at && !seen.has(at); at = nextOf.get(at)) { seen.add(at); if (stepsById.get(at)) out.push(stepsById.get(at)); }
  for (const s of chain.steps || []) if (!seen.has(s.id) && !s.parent_step_id) out.push(s);
  return out;
}

export function openable(url) {
  if (!url) return null;
  return /^https?:\/\//i.test(url) ? url : `https://${url}`;
}
